export default __webpack_public_path__ + "static/media/543.eda55e16.gif";